<template lang="pug">
div
	v-alert(v-if="$store.state.user.id" type="info" color="warning" @click="showConnectDifferDialog = true")
		| Ben je lid van de Nederlandse Ski Vereniging en heb je al een lidnummer?
		|
		a.white--text.font-weight-bold(@click="showConnectDifferDialog = true") Koppel dan hier je lidmaatschap aan je account.
	ws-dialog(v-model="showConnectDifferDialog" max-width="600px" persistent title="Koppel mijn lidmaatschap")
		template(v-if="deliveryIdentifier")
			v-card-text
				v-alert.mt-6.caption(type="info" text color="accent" dense) Er is een mail verstuurd naar <strong>{{deliveryIdentifier}}</strong>, klik op de link in de e-mail om je lidmaatschap te koppelen. Het kan mogelijk enkele minuten duren voordat de e-mail binnenkomt.
		template(v-else)
			validation-observer(v-slot="{ handleSubmit }")
				form(@submit.prevent="handleSubmit(linkDiffer)")
					v-card-text
						v-alert(v-if="status === 'not-found'" type="error" text)
							.font-weight-bold Geen actief lidmaatschap gevonden
							.caption Let op: koppelen kan alleen met een hoofdlidmaatschap.
							.caption Lukt het nog steeds niet? Neem dan contact op met de <a href="mailto:leden@wintersport.nl">ledenservice</a>
						p Vul je NSkiV lidnummer in, we sturen je een mail om de koppeling met je account te bevestigen.
						validation-provider(v-slot="{errors}" rules="required" name="NSkiV Lidnummer" slim)
							v-text-field(v-model="differId" name="token" label="NSkiV Lidnummer" type="text" :error-messages="errors")
					v-card-actions
						v-btn(color="primary" type="submit" block depressed :disabled="loading") Koppelen
</template>

<script>
import { gql } from 'graphql-tag';

export default {
	name: 'MembershipsLink',
	props: {
		hasDifferMembership: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showConnectDifferDialog: false,
			differId: null,
			deliveryIdentifier: null,
			status: null,
			loading: false
		};
	},
	methods: {
		linkDiffer() {
			this.loading = true;
			// eslint-disable-next-line promise/catch-or-return
			this.$graphClient
				.mutate({
					mutation: gql`
						mutation ($input: LinkDifferInput!) {
							LinkDiffer(input: $input) {
								deliveryIdentifier
							}
						}
					`,
					variables: {
						input: {
							relation: this.differId,
							redirect: window.location.href
						}
					}
				})
				.then(({ data }) => {
					if (!data.LinkDiffer) this.status = 'not-found';
					this.deliveryIdentifier = data.LinkDiffer.deliveryIdentifier;
					return data;
				})
				.catch(error => {
					this.deliveryIdentifier = null;
					this.$toast.error(error.message);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>
